import React from 'react';
import SettingsForm from '../ui-kit/SettingsForm';

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm
    withAutoResizeHeight={true}
    withAutoScroll={true}
    widgetSettings={widgetSettings}
    updateWidgetSettingsField={updateWidgetSettingsField}
  >
    <SettingsForm.Section>
      <SettingsForm.Section.Header />
      <SettingsForm.Section.Content>
        <SettingsForm.ToggleField
          fieldName="displayDetails"
          label={I18n.t('dashboards.widget_archetypes.announcements.settings.display_details')}
        />
        <SettingsForm.Select
          fieldName="columns"
          options={[1, 2, 3, 4, 5, 6]}
          label={I18n.t('dashboards.widget_archetypes.announcements.settings.columns')}
        />
      </SettingsForm.Section.Content>
    </SettingsForm.Section>
  </SettingsForm>
);

export default Settings;
